



























































































import CertificateRegistrationPopup from '@/components/popup/page/CertificateRegistration.vue'
import BankCreatePopups from '@/components/popup/BankCreatePopups.vue'
import PaymentPopups from '@/components/popup/PaymentPopups.vue'
import BankEnablingPopups from '@/components/popup/BankEnablingPopups.vue'
import TypeSelectionPopup from '@/components/popup/btt/TypeSelection.vue'
import DialogDrawer from '@/components/DialogDrawer.vue'
import StatusImg from '@/components/image/StatusImg.vue'
import ChangeStatusPopup from '@/components/popup/btt/ChangeStatus.vue'
import TaxInfo from '@/components/TaxInfo.vue'
import FooterLayout from '@/components/Footer.vue'
import HeaderLayout from '@/components/Header.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import Translation from '@/mixins/Translation'
import EmptyMessage from '@/components/EmptyMessage.vue'
import FooterButton from '@/components/FooterButton.vue'
import {LocaleMessage, TranslateResult} from 'vue-i18n'
import {Row} from 'element-ui'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import isFallbackLink from '@/validate/is-fallback-link'
import toCurrency from '@/filters/to-currency'
import PopupHandlerMixin from '@/mixins/popupHandler'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'

const biz = namespace('biz')
const taxes = namespace('taxes')
const layout = namespace('layout')
const payment = namespace('payment')
const institutions = namespace('institutions')
const gtm = namespace('gtm')

type DialogName = '' | 'confirmed' | 'expired' | 'paid-to-keep'

interface DialogOptions {
  title: string | LocaleMessage
  description: string | LocaleMessage
  status?: string
  showCancel: boolean
  closeFunc: (status: boolean) => void | null
  cancelText?: string | TranslateResult | null
  confirmText?: string | TranslateResult | null
  translation?: string
}

/**
 * @displayName TaxPage
 */
@Component({
  components: {
    FooterButton,
    MainLayout,
    CertificateRegistrationPopup,
    BankCreatePopups,
    PaymentPopups,
    BankEnablingPopups,
    TypeSelectionPopup,
    ChangeStatusPopup,
    FooterLayout,
    HeaderLayout,
    'confirmed': DialogDrawer,
    'expired': DialogDrawer,
    'paid-to-keep': DialogDrawer,
    StatusImg,
    [Row.name]: Row,
    TaxInfo,
    EmptyMessage,
  },
  filters: {
    toCurrency,
  },
})
export default class TaxPage extends Mixins(Translation, PopupHandlerMixin) {
  @Prop({default: null, type: String}) taxId: string | null
  @Prop({default: null, type: String}) paymentType: string | null
  @Prop({default: 0, type: Number}) windowScrollY: number

  @institutions.Getter('giroStatus') giroStatus: string
  @biz.State('name') bizName: string
  @biz.State('isCorporate') isCorporate: string
  @taxes.State('tax') tax
  @taxes.Action('getTax') getTax
  @taxes.Action('updateTaxStatus') updateTaxStatus
  @taxes.Mutation('clearTax') clearTax
  @layout.Mutation('updateError') updateError
  @payment.Mutation('updateTaxIds') updateTaxIds
  @payment.Mutation('updatePayments') updatePayments
  @payment.Mutation('updateTotalAmount') updateTotalAmount
  @payment.Mutation('clear') clear
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  loading: boolean = true
  changingStatus: boolean = false
  isEmptyPage: boolean = false
  dialogName: DialogName = ''
  open: boolean = false

  get taxStatus(): string {
    return this.tax ? this.tax.status : ''
  }

  get visibleMoreButton(): boolean {
    return this.taxStatus !== 'processing' && !this.isEmptyPage && !this.loading && this.taxStatus !== 'excluded'
  }

  get backwardName() {
    return 'taxes'
  }

  get taxTitle() {
    if(this.tax) {
      return this.tax.taxNm || this.ts('title-invalid')
    }
    return ' '
  }

  get isAvailablePaid(): boolean {
    const {taxStatus} = this
    return taxStatus === 'pending' || taxStatus === 'failed'
  }

  get isFooterVisible(): boolean {
    return  this.isAvailablePaid
  }

  get buttonOption() {
    const {tax, ts} = this
    const {amount} = tax ? tax : {} as any
    const title = [ts('payment-register')]
    title.unshift(`${toCurrency(amount)}${ts('KRW')}`)
    return {
      title: title.join(' '),
      kind: 'primary',
    }
  }

  get isEasyPayment() {
    return isFallbackLink(this.$route) && this.paymentType === 'easy'
  }

  get addTypes() {
    return [
      {
        title: '공동인증서로 계좌 연결하기',
        value: 'cert'
      },
      {
        title: '계좌 직접 입력하기',
        value: 'enter'
      }
    ]
  }

  get dialogOptions(): DialogOptions {
    const {ts} = this
    const options: DialogOptions = {
      title: '',
      description: '',
      status: '',
      showCancel: true,
      closeFunc: () => null,
      cancelText: null,
      confirmText: null,
      translation: '',
    }
    // eslint-disable-next-line default-case
    switch(this.dialogName) {
      case 'confirmed':
        options.title = ts('confirm.confirmed-tax.title')
        options.description = ts('confirm.confirmed-tax.description')
        options.translation = 'pages.tax.dialog.footer'
        options.status = 'none'
        options.closeFunc = (status: boolean) => {
          this.confirmedResult(status)
          this.dialogName = ''
        }
        options.cancelText = 'cancel'
        options.confirmText = 'confirm'
        break
      case 'expired':
        options.title = ts('confirm.confirmed-expired.title')
        options.description = ts('confirm.confirmed-expired.description')
        options.translation = 'pages.tax.dialog.footer'
        options.confirmText = 're-register'
        options.status = 'failed'
        options.closeFunc = (status: boolean) => {
          if(!status) {
            this.dialogName = ''
          } else {
            this.openPopup('certPopups')
            this.dialogName = ''
          }
        }
        options.cancelText = 'close'
        break
      case 'paid-to-keep':
        options.translation = 'pages.tax.dialog.footer'
        options.confirmText = 'confirm'
        options.showCancel = false
        break
    }

    return options
  }

  created() {
    this.clearTax()
    this.initData()
      .then(() => {
        this.logEventWithGroups({
          eventType: 'load_tax',
          eventProperties: {
            'status': this.ts(`status.${this.tax?.status}`),
            'product_id': this.taxId,
            'price': this.tax?.amount
          }
        })
      })
  }

  async initData() {
    await this.loadTax()
    if(this.isEasyPayment) {
      const {status} = this.tax
      if(status === 'pending' || status === 'failed') {
        const ANIMATION_DURATION = 600
        setTimeout(() => {this.goToPayment()}, ANIMATION_DURATION)
      }
    }
    if(this.giroStatus === 'expired' && this.isAvailablePaid) {
      this.openDialog('expired')
    }
  }

  loadTax() {
    return this.getTax({id: this.taxId})
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        const {status} = error.response || {}
        if(status === 404) {
          this.isEmptyPage = true
        } else {
          this.updateError({
            id: 'get-tax',
            message: this.ts('error.get-tax'),
          })
        }
        throw error
      })
  }

  confirmedResult(status) {
    if(status) {
      this.goToPayment()
    } else {
      this.clear()
    }
  }

  goToPayment() {
    this.updateTaxIds([this.taxId])
    this.updatePayments([this.tax])
    this.updateTotalAmount(this.tax.amount)
    this.openPopup('paymentPopups')
  }

  openDialog(dialogName) {
    this.dialogName = dialogName
    this.open = true
  }

  onFooter() {
    if(this.giroStatus === 'expired' && this.isAvailablePaid) {
      this.openDialog('expired')
    } else {
      this.openDialog('confirmed')
    }
  }

  onBackWards() {
    const taxesType = this.taxStatus === 'completed' ? 'already-pay' : 'need-pay'
    this.$router
      .replace({
        name: this.backwardName,
        query: {
          type: taxesType
        }
      })
      .catch((err) => err)
  }

  onGoToMain() {
    this.$router
      .replace({name: 'home'})
      .catch((err) => err)
  }

  onClickBackward() {
    this.onBackWards()
  }

  onClickTaxMore() {
    const {isForcedPayment, status} = this.tax || {}
    if(status === 'completed' && !isForcedPayment) {
      this.openDialog('paid-to-keep')
    } else {
      this.openPopup('changeStatus')
    }
  }

  onChangeStatus(status) {
    this.changingStatus = true
    this.updateTaxStatus({id: this.taxId, status})
      .then(() => {
        this.loadTax()
      })
      .catch((error) => {
        this.updateError({
          id: 'update-tax-status',
          message: this.ts('error.update-tax-status'),
        })
        throw error
      })
      .finally(() => {
        this.changingStatus = false
      })
  }

  onCloseCertPopup(value) {
    this.setPopupStatus('certPopups', value)
    this.initData()
  }

  onSelectType(type) {
    if(type === 'enter') {
      this.openPopup('bankCreatePopups')
    } else if(type === 'cert') {
      this.$router
        .push({
          name: 'cert-center',
          query: {
            callerPath: this.$route.fullPath,
            openPopupName: 'bankEnabling',
          }
        })
        .catch((err) => err)
    }
  }

  onOpenTypePopup() {
    if(this.isCorporate) {
      this.openPopup('certType')
    } else {
      this.onSelectType('enter')
    }
  }
}
